import { WebApiService } from '../../../plugins/webApiService'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import InviteToEstimateRequest from '../../../projects/task/i-service/models/estimate/InviteToEstimateRequest';
import RemoveInviteFromEstimateRequest from '../../../projects/task/i-service/models/estimate/RemoveInviteFromEstimateRequest';
import GetInvitesEstimateListRequest from '../../../projects/task/i-service/models/estimate/GetInvitesEstimateListRequest';
import CheckEstimateRequest from '../../../projects/task/i-service/models/estimate/CheckEstimateRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import InviteToEstimateResponse from '../../../projects/task/i-service/models/estimate/InviteToEstimateResponse';
import RemoveInviteFromEstimateResponse from '../../../projects/task/i-service/models/estimate/RemoveInviteFromEstimateResponse';
import GetInvitesEstimateListResponse from '../../../projects/task/i-service/models/estimate/GetInvitesEstimateListResponse';
import CheckEstimateResponse from '../../../projects/task/i-service/models/estimate/CheckEstimateResponse';

/**
 * * Сервис приглашений на оценку
 */
export default class EstimateInviteService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	
	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
	}

	/**
	 * * Приглашение на оценку
	 */
	async InviteToEstimate(request: InviteToEstimateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'EstimateInviteService',
			Method: 'InviteToEstimate',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление пользователя из приглашенных на оценку
	 */
	async RemoveInviteFromEstimate(request: RemoveInviteFromEstimateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'EstimateInviteService',
			Method: 'RemoveInviteFromEstimate',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка приглашенных
	 */
	async GetInvitesEstimateList(request: GetInvitesEstimateListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'EstimateInviteService',
			Method: 'GetInvitesEstimateList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Метод который возращает true если пользователя пригласили на оценку задачи
	 */
	async CheckEstimate(request: CheckEstimateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'EstimateInviteService',
			Method: 'CheckEstimate',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Приглашение на оценку
	 */
	async inviteToEstimateAsync(request: InviteToEstimateRequest): Promise<InviteToEstimateResponse> {
		return new Promise<InviteToEstimateResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'EstimateInviteService',
				Method: 'InviteToEstimate',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<InviteToEstimateResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as InviteToEstimateResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление пользователя из приглашенных на оценку
	 */
	async removeInviteFromEstimateAsync(request: RemoveInviteFromEstimateRequest): Promise<RemoveInviteFromEstimateResponse> {
		return new Promise<RemoveInviteFromEstimateResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'EstimateInviteService',
				Method: 'RemoveInviteFromEstimate',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<RemoveInviteFromEstimateResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as RemoveInviteFromEstimateResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка приглашенных
	 */
	async getInvitesEstimateListAsync(request: GetInvitesEstimateListRequest): Promise<GetInvitesEstimateListResponse> {
		return new Promise<GetInvitesEstimateListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'EstimateInviteService',
				Method: 'GetInvitesEstimateList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetInvitesEstimateListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetInvitesEstimateListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Метод который возращает true если пользователя пригласили на оценку задачи
	 */
	async checkEstimateAsync(request: CheckEstimateRequest): Promise<CheckEstimateResponse> {
		return new Promise<CheckEstimateResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'EstimateInviteService',
				Method: 'CheckEstimate',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<CheckEstimateResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as CheckEstimateResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}